const Unauthorized = () => (
  <div className="min-h-screen supports-[height:100dvh]:min-h-dvh flex items-center justify-center px-4 text-center">
    <h1 className="text-2xl font-bold text-red-600">
      Access Denied 🚫
    </h1>
  </div>
);

export default Unauthorized;
